module.exports = __webpack_public_path__ + "5efe4cf7598cbc2f3916446aa857a38f.MP3";